import React from 'react';
import type { ReactNode } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, ArrowRight } from 'lucide-react';
interface QuestionStepProps {
  section: string;
  children: ReactNode;
  onNext: () => void;
  onBack?: () => void;
  isValid?: boolean;
  helperText?: string;
}
export function QuestionStep({
  section,
  children,
  onNext,
  onBack,
  isValid = true,
  helperText
}: QuestionStepProps) {
  return <div className="space-y-16 py-8">
      <div className="space-y-12">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        ease: [0.25, 0.1, 0.25, 1]
      }} className="flex justify-center">
          <span className="text-xs font-medium text-[#9B87C7] uppercase tracking-[0.2em] opacity-80">
            {section}
          </span>
        </motion.div>

        <div className="space-y-8 text-center">
          {children}
          {helperText && <motion.p initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.5,
          duration: 1
        }} className="text-base text-[#9B95A3] mt-6 leading-relaxed max-w-lg mx-auto font-light">
              {helperText}
            </motion.p>}
        </div>
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 40
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.3,
      duration: 1,
      ease: [0.25, 0.1, 0.25, 1]
    }} className="flex justify-center items-center gap-8 pt-12">
        {onBack && <motion.button onClick={onBack} whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.98
      }} transition={{
        duration: 0.5,
        ease: [0.25, 0.1, 0.25, 1]
      }} className="w-16 h-16 rounded-full bg-[#F8F8FA] text-[#2D2A35] hover:bg-[#F0F0F2] transition-colors duration-500 flex items-center justify-center shadow-sm hover:shadow-md">
            <ArrowLeft className="w-6 h-6 stroke-[1.5]" />
          </motion.button>}

        <motion.button onClick={onNext} disabled={!isValid} whileHover={{
        scale: isValid ? 1.05 : 1
      }} whileTap={{
        scale: isValid ? 0.98 : 1
      }} transition={{
        duration: 0.5,
        ease: [0.25, 0.1, 0.25, 1]
      }} className="w-16 h-16 rounded-full gradient-button tactile-texture text-white organic-shadow hover:shadow-xl transition-all duration-500 flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed">
          <ArrowRight className="w-6 h-6 stroke-[1.5] relative z-10" />
        </motion.button>
      </motion.div>
    </div>;
}